import { useState, useEffect } from 'react';
function useScreenSize() {
    const [screenSize, setScreenSize] = useState({
        isSmall: false,
        isMedium: false,
        isLarge: false,
        isExtraLarge: false,
    });
    useEffect(() => {
        const updateScreenSize = () => {
            const width = window.innerWidth;
            const actualWidth = Math.max(width, window.screen.width);
            setScreenSize({
                isSmall: actualWidth <= 767,
                isMedium: actualWidth >= 768 && actualWidth <= 1023,
                isLarge: actualWidth >= 1024 && actualWidth <= 1439,
                isExtraLarge: actualWidth >= 1440,
            });
        };
        updateScreenSize();
        window.addEventListener('resize', updateScreenSize);
        return () => {
            window.removeEventListener('resize', updateScreenSize);
        };
    }, []);
    return screenSize;
}
export default useScreenSize;
